export enum SummaryStatus {
    New = 'new',
    Processing = 'processing',
    Completed = 'completed',
    Failed = 'failed'
}